<template>
  <div class="skeleton-title">
    <Skeleton class="mb-4" width="30rem" height="5rem" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style lang="scss" scoped></style>
